import { IonIcon, IonItem, IonLabel } from '@ionic/react';
import clsx from 'clsx';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  item: {
    '--background': 'transparent',
    '--background-hover': 'rgba(var(--ion-color-dark-rgb), 0.055)',
    '--background-hover-opacity': 1,
    '--padding-start': '13px',
    '--padding-end': '13px',
    '--inner-padding-end': '0',
    '--min-height': '38px',
    margin: 0,
    borderRadius: 12,
    transition: 'background-color 120ms ease',
  },
  icon: {
    color: 'var(--ion-color-dark)',
    opacity: 0.75,
    fontSize: 20,
    marginInlineEnd: 11,
  },
  labelText: {
    fontWeight: 500,
    fontSize: 16,
    color: 'var(--ion-color-dark)',
  },
  selected: {
    '--background': 'rgba(var(--ion-color-primary-rgb), 0.08)',
    '--background-hover': 'rgba(var(--ion-color-primary-rgb), 0.08)',
  },
  selectedContent: {
    color: 'var(--ion-color-primary)',
  },
  selectedIcon: {
    opacity: 0.8,
  },
});

export interface IMenuItem {
  url: string;
  icon: string;
  title: string;
  selected: boolean;
}

const MenuItem: React.FC<IMenuItem> = ({ url, icon, title, selected }) => {
  const classes = useStyles();

  return (
    <IonItem
      className={clsx(classes.item, selected && classes.selected)}
      routerLink={url}
      routerDirection="none"
      lines="none"
      detail={false}
    >
      <IonIcon
        slot="start"
        icon={icon}
        className={clsx(
          classes.icon,
          selected && classes.selectedContent,
          selected && classes.selectedIcon
        )}
      />
      <IonLabel>
        <span className={clsx(classes.labelText, selected && classes.selectedContent)}>
          {title}
        </span>
      </IonLabel>
    </IonItem>
  );
};

export default MenuItem;
